import * as React from "react"
import { Helmet } from "react-helmet"
import { useIntl } from "gatsby-plugin-intl"

import QlikClassicAppEmbed from "../../components/qlik/QlikClassicAppEmbed"

const styles = {
  section: {
    padding: "100px 0 0",
    marginLeft: "auto",
    marginRight: "auto",
  },
  container: {
    margin: "0 auto",
    // padding: "0 24px",
  },
}

const tenantUrl = process.env.GATSBY_QLIK_TENANT_URL
const clientId = process.env.GATSBY_QLIK_CLIENT_ID
const defaultSheetId = process.env.GATSBY_QLIK_SHEET_ID
const defaultQlikHeading = "Media Insights Platform"
const defaultQlikSourceText = "Source: Leger 2023, Dynata 2026"

const trimText = value => String(value || "").trim()

const PageQlikPortalBlock = ({ block, appId, sheetId }) => {
  const { locale } = useIntl()
  const isFrench = String(locale).startsWith("fr")
  const qlikHeading = trimText(block?.qlikHeading) || defaultQlikHeading
  const qlikSourceText =
    trimText(block?.qlikSourceText) || defaultQlikSourceText
  const qlikCtaLabel = trimText(block?.qlikCtaLabel)
  const qlikCtaFile = block?.qlikCtaFile
  const qlikCtaUrl = trimText(qlikCtaFile)
  const defaultAppId = isFrench
    ? process.env.GATSBY_QLIK_PUBLIC_APP_FRENCH_ID ||
      process.env.GATSBY_QLIK_PUBLIC_APP_ID
    : process.env.GATSBY_QLIK_PUBLIC_APP_ID
  const selectedAppId = trimText(appId) || defaultAppId
  const selectedSheetId = trimText(sheetId) || defaultSheetId
  const loadingText = isFrench
    ? "Chargement de la plateforme Media Insights…"
    : "Loading Media Insights Platform…"

  return (
    <section
      className="page-qlik-portal-block"
      key={block?.id || "pageQlikPortal"}
      style={styles.section}
    >
      <Helmet>
        <script
          src="https://cdn.jsdelivr.net/npm/@qlik/embed-web-components@1/dist/index.min.js"
          type="application/javascript"
          crossOrigin="anonymous"
          data-host={tenantUrl}
          data-client-id={clientId}
          data-auth-type="Oauth2"
          data-get-access-token="getAccessToken"
        />
      </Helmet>

      <div style={styles.container}>
        <QlikClassicAppEmbed
          tenantUrl={tenantUrl}
          clientId={clientId}
          appId={selectedAppId}
          sheetId={selectedSheetId}
          pageLocale={locale}
          loadingText={loadingText}
          heading={qlikHeading}
          sourceText={qlikSourceText}
          sourceCta={{
            label: qlikCtaLabel,
            url: qlikCtaUrl,
          }}
        />
      </div>
    </section>
  )
}

export default PageQlikPortalBlock
